import VisibilityIcon from '@mui/icons-material/Visibility';
import { darken, IconButton, Stack, Typography } from '@mui/material';
import { _ } from '/@/locale';

const SavedField = ({ label, value }: { label: string; value?: string }) => (
    <Stack spacing={0.5} alignItems='flex-start'>
        <Typography variant='caption' color='primary'>
            {label}
        </Typography>
        <Typography variant='subtitle2' color='primary' fontWeight='bold'>
            {value || '-'}
        </Typography>
    </Stack>
);

const SavedAnalysis = ({
    consultations,
    onSee,
}: {
    consultations: Array<{ date?: string; note?: string; bagQuality?: { batch?: string; hybrid?: string } }>;
    onSee: (batch: string, note?: string) => void;
}) => {
    return (
        <Stack spacing={2} sx={{ backgroundColor: '#F5F5F5', p: 2 }}>
            <Typography variant='subtitle1' color='primary' fontWeight='bold'>
                {_('Análisis guardados')}
            </Typography>
            {consultations.map((item, index) => {
                const batch = item.bagQuality?.batch ?? '';
                return (
                    <Stack
                        // biome-ignore lint/suspicious/noArrayIndexKey: batches may repeat across saved consultations
                        key={`${batch}-${index}`}
                        direction='row'
                        alignItems='center'
                        justifyContent='space-between'
                        sx={{
                            backgroundColor: '#fff',
                            border: (t) => `1px solid ${t.palette.divider}`,
                            p: 2,
                            '&:hover': { backgroundColor: darken('#f5f5f5', 0.1) },
                        }}
                        onClick={() => onSee(batch, item.note)}
                        component='button'
                    >
                        <Stack direction='row' spacing={3} flexWrap='wrap' useFlexGap>
                            <SavedField label={_('Fecha')} value={item.date} />
                            <SavedField label={_('Lote')} value={batch} />
                            <SavedField label={_('Híbrido')} value={item.bagQuality?.hybrid} />
                        </Stack>
                        <IconButton size='small' color='primary' disabled={!batch} aria-label={_('Ver')}>
                            <VisibilityIcon />
                        </IconButton>
                    </Stack>
                );
            })}
        </Stack>
    );
};

export default SavedAnalysis;
